import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { allArticles, getSectionName, shortDate } from '@/utils/content';

export default function SearchResultsSection({ keyword }: { keyword: string }) {
  const lower = keyword.toLowerCase();
  const results = allArticles.filter((article) => {
    const haystack = [article.title, article.summary, article.tags.join(' '), getSectionName(article.section)]
      .join(' ')
      .toLowerCase();
    return haystack.includes(lower);
  });

  return (
    <section id="search" className="w-full scroll-mt-20 border-b border-background-200 bg-accent-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.25em] text-accent-800">站内搜索</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              「{keyword}」的搜索结果
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              共找到 {results.length} 条相关整理。
            </p>
          </div>
          <Link
            to="/"
            className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            <i className="ri-close-circle-line" /> 清除搜索
          </Link>
        </div>

        {results.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {results.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-lg border border-dashed border-accent-300 bg-background-50 p-10 text-center">
            <p className="font-heading text-lg font-bold text-foreground-900">暂时没找到相关内容</p>
            <p className="mt-2 text-sm text-foreground-600">
              换个关键词试试，或者直接从板块导航进入分区浏览。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              最近更新：{shortDate(allArticles[0]?.date ?? '2026-09-12')}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}